import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Empty, Pagination, Tabs, message } from 'antd';
import HwzTitle from '../widget/HwzTitle';
import HwzComponent from '../../common/component/HwzComponent';
import Pager from '../../common/model/base/Pager';
import Share from '../../common/model/share/Share';
import ShareBar from './widget/ShareBar';
import './List.less';
import Lang from '../../common/model/global/Lang';
import SortDirection from '../../common/model/base/SortDirection';
import Moon from '../../common/model/global/Moon';


const { TabPane } = Tabs;

interface IProps extends RouteComponentProps {}

interface IState {
  activeTab: string;
  loading: boolean;
}

export default class List extends HwzComponent<IProps, IState> {
  mySharePager = new Pager<Share>(this, Share, Pager.MAX_PAGE_SIZE);
  sharedToMePager = new Pager<Share>(this, Share, Pager.MAX_PAGE_SIZE);

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      activeTab: 'myShare',
      loading: false
    };
  }

  componentDidMount() {
    console.log('List component mounted');
    
    this.mySharePager.enableHistory();
    this.mySharePager.setFilterValue('orderCreateTime', SortDirection.DESC);
    
    this.sharedToMePager.enableHistory();
    this.sharedToMePager.setFilterValue('orderCreateTime', SortDirection.DESC);
    
    this.refreshMyShare();
  }


  refreshSharedToMe() {
    console.log('Refreshing shares to me...');
    const currentUser = Moon.getSingleton().user;
    console.log('Current user for shared to me:', currentUser);
    
    if (!currentUser.uuid) {
      console.warn('No current user found');
      message.warning(Lang.t('nologin', '未登录'));
      return;
    }
    
    this.setState({ loading: true });
    
    // 修改 fetchWithCustomParams 方法，使其能够接收回调函数
    this.fetchWithCustomParams(this.sharedToMePager, 'sharedToMe', undefined, () => {
      this.setState({ loading: false });
    });
  }
  
  // 修改 refresh 方法
  refreshMyShare() {
    const currentUser = Moon.getSingleton().user;
  
    if (!currentUser.uuid) {
      message.warning(Lang.t('nologin', '未登录'));
      return;
    }
    
    this.setState({ loading: true });
    
    // 修改 fetchWithCustomParams 方法，使其能够接收回调函数
    this.fetchWithCustomParams(this.mySharePager, 'myShare', currentUser.uuid, () => {
      this.setState({ loading: false });
    });
  }
  
  handleTabChange = (activeKey: string) => {
    console.log('Tab changed to:', activeKey);
    this.setState({ activeTab: activeKey });
    
    if (activeKey === 'myShare') {
      this.refreshMyShare();
    } else if (activeKey === 'sharedToMe') {
      this.refreshSharedToMe();
    }
  };
 
  // 修改 fetchWithCustomParams 方法，添加回调参数
  fetchWithCustomParams(pager: Pager<Share>, queryType: string, userUuid?: string, callback?: () => void) {
    // 保存原始的 httpList 方法
    const originalHttpList = pager.httpList.bind(pager);
    
    // 临时重写 httpList 方法
    pager.httpList = (successCallback?: any, errorCallback?: any) => {
      // 保存原始的 getParams 方法
      const originalGetParams = pager.getParams.bind(pager);
      
      // 重写 getParams 方法以包含我们的自定义参数
      pager.getParams = () => {
        const params = originalGetParams();
        // 添加我们需要的参数
        params.queryType = queryType;
        if (userUuid) {
          params.userUuid = userUuid;
        }
        console.log('Custom params for request:', params);
        return params;
      };
      
      // 创建新的回调函数，在原始回调执行后执行我们的回调
      const newSuccessCallback = (data: any) => {
        if (successCallback) successCallback(data);
        if (callback) callback();
      };
      
      const newErrorCallback = (error: any) => {
        if (errorCallback) errorCallback(error);
        if (callback) callback();
      };
      
      // 调用原始的 httpList 方法
      originalHttpList(newSuccessCallback, newErrorCallback);
      
      // 恢复原始的 getParams 方法
      pager.getParams = originalGetParams;
    };
    
    // 调用修改后的 httpList 方法
    pager.httpList();
    
    // 恢复原始的 httpList 方法
    pager.httpList = originalHttpList;
  }
  
  changePage(page: number, pager: Pager<Share>) {
    console.log(`Changing page to ${page} for pager:`, pager);
    pager.page = page - 1;
    
    if (this.state.activeTab === 'myShare') {
      this.refreshMyShare();
    } else {
      this.refreshSharedToMe();
    }
  }

  // 渲染分享项详情信息（用于调试）
  renderShareDetails(share: Share) {
    const currentUser = Moon.getSingleton().user;
    if (!currentUser.uuid) return null;
    
    const isSharedToMe = share.userUuid !== currentUser.uuid && 
      (share.shareScope === 'PUBLIC' || 
       (share.shareScope === 'PRIVATE' && share.targetUserUuids && share.targetUserUuids.includes(currentUser.uuid)));
    
    return (
      <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
        <div>{Lang.t('user.createUser', '创建人')}: {share.username} ({share.userUuid})</div>
        <div>{Lang.t('share.shareScope', '分享范围')}: {share.shareScope}</div>
        <div>{Lang.t('share.targetUsers', '目标用户数')}: {share.targetUserUuids?.length || 0}</div>
        <div>{Lang.t('share.isSharedToMe', '是否分享给我')}: {isSharedToMe ? Lang.t('yes', '是') : Lang.t('no', '否')}</div>
      </div>
    );
  }

  renderMyShare() {
    const { mySharePager } = this;

    return (
      <div>
        {mySharePager.data.map((share, index) => {
          return (
            <div key={share.uuid!}>
              <ShareBar
                share={share}
                onDeleteSuccess={() => this.refreshMyShare()}
                showDelete={true}
              />
            </div>
          );
        })}

        {mySharePager.data.length > 0 && (
          <Pagination
            className="mt10 pull-right"
            onChange={(page) => this.changePage(page, mySharePager)}
            current={mySharePager.page + 1}
            total={mySharePager.totalItems}
            pageSize={mySharePager.pageSize}
            hideOnSinglePage
          />
        )}

        {mySharePager.isEmpty() && (
          <Empty description={Lang.t('share.emptyHint', '暂无任何分享')} />
        )}
      </div>
    );
  }

  renderSharedToMe() {
    const { sharedToMePager } = this;

    return (
      <div>
        {sharedToMePager.data.map((share, index) => {
          console.log(`Shared to me ${index}:`, share);
          return (
            <div key={share.uuid!}>
              <ShareBar
                share={share}
                onDeleteSuccess={() => this.refreshSharedToMe()}
                showDelete={false}
              />
            </div>
          );
        })}

        {sharedToMePager.data.length > 0 && (
          <Pagination
            className="mt10 pull-right"
            onChange={(page) => this.changePage(page, sharedToMePager)}
            current={sharedToMePager.page + 1}
            total={sharedToMePager.totalItems}
            pageSize={sharedToMePager.pageSize}
            hideOnSinglePage
          />
        )}

        {sharedToMePager.isEmpty() && (
          <Empty description={Lang.t('share.sharedToMeEmptyHint', '暂无别人分享给你的文件')} />
        )}
      </div>
    );
  }

  render() {
    const { activeTab, loading } = this.state;

    return (
      <div className="share-list">
        <HwzTitle name={Lang.t('layout.myShare', '我的分享')} />

        <Tabs 
          activeKey={activeTab} 
          onChange={this.handleTabChange}
          tabBarExtraContent={loading ? <span>{Lang.t('loading', '加载中...')}</span> : null}
        >
          <TabPane tab={Lang.t('share.myShareToOthers', '我分享给别人')} key="myShare">
            {this.renderMyShare()}
          </TabPane>
          <TabPane tab={Lang.t('share.othersShareToMe', '别人分享给我')} key="sharedToMe">
            {this.renderSharedToMe()}
          </TabPane>
        </Tabs>
      </div>
    );
  }
}